
<template>
    <header class="header">
        <nav class="navbar navbar-expand-lg fixed-top bg-white py-0 time02 shadow">
            <div class="container-fluid px-3 px-lg-5 d-flex justify-content-between align-items-center position-relative h-100">
                <router-link to="/" class="navbar-brand p-0 m-0 lh-1 letterA">FOSA</router-link>
                <div class="collapse navbar-collapse px-3 px-xl-0 border-top" id="navbarToggler">
                    <ul class="navbar-nav mb-0 mb-lg-0 d-block d-lg-flex justify-content-lg-end py-3 py-lg-0 w-100">
                        <li class="nav-item">
                            <div class="nav-link px-0">
                                <router-link to="/" class="text-uppercase" exact>Home</router-link>
                            </div>
                        </li>
                        <li class="nav-item">
                            <div class="nav-link px-0">
                                <router-link to="/about" class="text-uppercase" exact>About</router-link>
                            </div>
                        </li>
                        <li class="nav-item dropdown">
                            <div class="nav-link px-0">
                                <router-link to="/projects/0" class="text-uppercase" exact>Projects</router-link>
                                <i class="bi bi-chevron-down d-lg-none"></i>
                            </div>
                            <ul class="dropdown-menu time01">
                                <li v-for="(item,index) in menus" :key="index"><router-link class="dropdown-item" :to="{path:'/projects/'+ item.type}">{{item.name}}</router-link></li>
                            </ul>
                        </li>
                        <li class="nav-item dropdown">
                            <div class="nav-link px-0">
                                <router-link to="/branding" class="text-uppercase" exact>branding</router-link>
                                 <i class="bi bi-chevron-down d-lg-none"></i>
                            </div>
                            <ul class="dropdown-menu time01">
                                <li><router-link class="dropdown-item" to="/branding">Projects</router-link></li>
                                <li><router-link class="dropdown-item" to="/introduction">Introduction</router-link></li>
                                <li><router-link class="dropdown-item" to="/services">Services</router-link></li>
                            </ul>
                        </li>
                        <li class="nav-item dropdown">
                            <div class="nav-link px-0">
                                <router-link to="/articles" class="text-uppercase" exact>writings</router-link>
                                <i class="bi bi-chevron-down d-lg-none"></i>
                            </div>
                            <ul class="dropdown-menu time01">
                                <li><router-link class="dropdown-item" to="/articles">Articles</router-link></li>
                                <li><router-link class="dropdown-item" to="/publications">Publications</router-link></li>
                            </ul>
                        </li>
                        <li class="nav-item">
                            <div class="nav-link px-0">
                                <router-link to="/contact" class="text-uppercase" exact>Contact</router-link>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="d-flex align-items-center">
                    <button class="navbar-toggler collapsed border-0 ms-3 order-4" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="icon-bar time03"></span>
                        <span class="icon-bar time03"></span>
                        <span class="icon-bar time03"></span>
                    </button>
                </div>
            </div>
        </nav>
    </header>
</template>
  
<script>
import axios from '@/axios-auth'
export default {
    data () {
        return {
            menus:[],
        }
    },
    created(){
        axios.get('/projects.json')
            .then( res => {
                return res.data
            })
            .then( response => {
                if(response.code == 0){
                    this.projects = response.data
                    // console.log(response.data)
                    response.data.forEach((project) => {
                        this.menus.push(project.menu)
                    })
                
                }
            })

        // console.log(this.lists)
        //  console.log(this.curType)
    },
    methods: {
        dropdown(){
            
        }
    },
    mounted(){
        this.$nextTick(function(){
            $('.nav-link .bi').click(function(){
                if($(this).hasClass('rotate')){
                    $(this).removeClass('rotate')
                    $(this).parent().siblings('.dropdown-menu').slideUp(200)
                }else{
                    $(this).addClass('rotate')
                    $(this).parent().siblings('.dropdown-menu').slideDown(200)
                }
                
            })
        })
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar{height: 60px;}
.navbar-brand{ font-size: 20px; font-weight: bold;}
.navbar-collapse { position: absolute; left: 0; right: 0; top: 60px; height: calc(100vh - 60px); background-color: #fff; overflow-y: auto;}
.navbar-collapse .router-link-exact-active{ color: #CBB778;}
.navbar-toggler{ width: 22px; height: 34px; position: relative; outline: none; padding: 0; border: 0;}
.navbar-toggler .icon-bar{width: 18px; height: 2px;  transform: rotate(0deg); background-color: #000; position: absolute; left: 50%;  margin-left: -9px;}
.navbar-toggler .icon-bar+.icon-bar{ margin-top: 0;}
.navbar-toggler .icon-bar:nth-child(1){ transform: rotate(45deg); top: 15px}
.navbar-toggler .icon-bar:nth-child(2){ transform: rotate(-45deg); top: 15px}
.navbar-toggler .icon-bar:nth-child(3){ display: none;}  
.navbar-toggler.collapsed .icon-bar:nth-child(1){ top:9px;transform: rotate(0deg);}
.navbar-toggler.collapsed .icon-bar:nth-child(2){top:16px; transform: rotate(0deg);}
.navbar-toggler.collapsed .icon-bar:nth-child(3){ bottom:9px; display: block;}
.navbar-toggler:focus{box-shadow: none;}
.nav-link{ position: relative; font-weight: 600; letter-spacing: 3px;}
.nav-item{ padding-top: 5px; padding-bottom: 5px;}
.nav-link i{ position: absolute; left: 0; right: 0; top: 0; bottom: 0; display: flex; justify-content: end; align-items: center;}
.nav-link i::before{transition: all .3s ease-out 0s;}
.nav-link i.rotate::before{transform: rotate(180deg);}
.dropdown-item{ font-size: 14px; padding: 10px; color: #666;}
.dropdown-menu{ border-left: 0;border-right: 0;border-bottom: 0; border-radius: 0;}

@media (min-width: 576px) {
    
}

@media (min-width: 768px) {

}

@media (min-width: 992px) {
    .navbar{ height: 80px;}
    .navbar-brand{ font-size: 30px}
    .navbar-collapse{ position:static; height: auto; overflow: inherit; border: 0 !important;}
    .nav-link{ position: relative; height: 80px; display: flex; align-items: center; font-size: 15px;}
    .nav-item:first-child { margin-left: 0;}
    .nav-item:last-child { margin-right: 0;}
    .nav-link::before{ content: ''; display: block; width: 0; position: absolute; left: 50%; bottom: 0; height: 2px; transition: all .2s ease-out 0s;  transform: translateX(-50%); background-color: #D6BF98;}
    .nav-link a{ display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;}
    .nav-item{ padding-top: 0; padding-bottom: 0; margin: 0 25px;}

    .nav-item:hover .nav-link::before{width: 100%;}
    .dropdown:hover .dropdown-menu{ left: 50%; transform: translateX(-50%); display: block; border-radius: 0 0 10px 10px; border: 0; box-shadow: 0 3px 15px rgba(0, 0, 0, .06);}
    .dropdown-item{ text-align: center;}
    .dropdown-item:hover{ color: #D6BF98;}
}

@media (min-width: 1200px) {
    
}

@media (min-width: 1400px) {

}
</style>
  


// WEBPACK FOOTER //
// src/components/Header.vue